module.exports = __webpack_public_path__ + "img/pic-01.c09047fc.png";